/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import profileIcon from 'assets/images/profileIcon.svg';
import CN from 'classnames';
import { Button } from 'components/atoms';
import { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import MenuDrawer from './MenuDrawer';

export interface HeaderProps {
  [x: string]: any;
  userDetails?: any;
  firstRoute?: any;
  menuItemList?: any;
}

export const Header: FC<HeaderProps> = ({
  className,
  userDetails = undefined,
  firstRoute = undefined,
  menuItemList = undefined,
  ...restProps
}: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const HeaderClasses = CN(
    'main-layout__header z-10 h-[70px] pl-2 md:pr-2 pr-1 py-[12px] flex justify-between items-center w-full bg-white',
    className,
  );
  const { userDetails: user }: any = useSelector<any>((state) => state.user);
  const [isOpenProfileDropdown, setIsOpenProfileDropdown] = useState(false);
  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);

  // Ref for the dropdown menu container
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpenProfileDropdown(!isOpenProfileDropdown);
  };

  const handleProfilePage = () => {
    toggleDropdown();
    navigate('/profile');
  };

  const handleSignOut = () => {
    toggleDropdown();
    localStorage.clear();
    navigate('/auth/login', { replace: true });
  };

  const [header, setHeader] = useState('');

  const pageHeaderMapping: Record<string, string> = {
    '/': 'Dashboard',
    '/videos': 'Videos',
    '/videos/upload': 'Videos',
    '/profile': 'Profile',
    '/videos/:id': 'Videos',
  };

  useEffect(() => {
    const path = location.pathname;

    const matchedHeader =
      Object?.entries(pageHeaderMapping)?.find(([pattern]) => {
        // Convert route pattern to RegExp (e.g., "/videos/:id" -> /^\/videos\/[^/]+$/)
        const regexPattern = new RegExp(`^${pattern?.replace(/:[^/]+/g, '[^/]+')}$`);
        return regexPattern.test(path);
      })?.[1] ?? '';

    setHeader(matchedHeader);
  }, [location.pathname]);

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpenProfileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <header className={HeaderClasses} {...restProps}>
      <div className="header__left flex items-center py-[6px]">
        <i
          className="ri-menu-line text-lg pr-3 text-neutral-700 pl-2"
          onClick={() => {
            setIsMenuDrawerOpen(true);
          }}
        />
        <span className="md:text-3xl text-xl font-semibold px-2 text-[#F7941E]">{header}</span>
      </div>

      <div className="header__left flex items-center">
        <div className="h-14 flex items-center justify-start rounded ml-6 md:pr-5 pr-2">
          <Button
            size="sm"
            className="hidden md:block mr-8"
            onClick={() => {
              if (user?.status !== 'completed') {
                notify('Please complete your profile before uploading videos.', 'error');
              } else {
                navigate('/videos/upload');
              }
            }}
          >
            <i className="ri-add-line pr-1" />
            Upload
          </Button>

          <img
            src={profileIcon}
            alt="profile-icon"
            className="md:w-[40px] md:h-[40px] w-[35px] h-[35px]"
          />
          <div className="flex md:pl-4 pl-2">
            <div className="flex text-sm font-medium text-[#151D48] capitalize flex-col">
              {user?.name ?? ''}
              <div className="text-xs font-normal text-[#737791] pt-1">Content Creator</div>
            </div>
            <div className="relative pl-3 md:pl-2 pt-2" ref={dropdownRef}>
              <i
                className="ri-arrow-down-s-line text-xl cursor-pointer leading-none"
                onClick={toggleDropdown}
              />

              {isOpenProfileDropdown && (
                <div className="absolute top-[14px] right-0 mt-3 w-[110px] bg-white shadow-lg rounded-md border border-gray-300">
                  <button
                    onClick={handleProfilePage}
                    className="w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                  >
                    My Profile
                  </button>
                  <button
                    onClick={handleSignOut}
                    className="w-full text-left px-3 py-2 text-red-700 hover:bg-gray-100 rounded-b-lg"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <MenuDrawer
        isOpen={isMenuDrawerOpen}
        onClose={() => setIsMenuDrawerOpen(false)}
        menuItemList={menuItemList}
        firstRoute={firstRoute}
        userDetails={userDetails}
        setIsMenuDrawerOpen={setIsMenuDrawerOpen}
      />
    </header>
  );
};

export default Header;
